/**
 * Created by nemio on 08.12.2015.
 */

import React, {Component, PropTypes} from 'react';
import DOMPurify from 'dompurify';

import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {VelocityComponent} from 'velocity-react';

class BgSliderItem extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  _openAsset() {

    if (_get(this.props, 'item.asset.id', null)) this.props.onAssetSelect(this.props.item.asset);
  }

  _renderItem() {

    switch (this.props.item.type) {

      case 'asset':
        return (
          <div className="bg_slider-link movie-ref" onClick={this._openAsset.bind(this)}></div>
        );

      case 'url':
        return (
          <a href={this.props.item.url} rel="noopener noreferrer" target="_blank">
            <div className="bg_slider-link movie-ref"></div>
          </a>
        );

      default:
        console.warn('Unsupported slider item data: ', this.props.item);
        return <div></div>
    }
  }

  _renderDescription() {
    var string = '';

    if (this.props.item.type === 'asset' && !_isEmpty(this.props.item.asset)) {
      string = _get(this.props.item, 'asset.title', '');

      if (_get(this.props.item, 'asset.type') !== 'channel') {
        string += _get(this.props.item, 'asset.year', '') && ' (' + _get(this.props.item, 'asset.year', '') + ')'
      }
    }

    return <span className="bg_slider-date">{string}</span>;
  }

  /**
   * @method render
   * @returns {JSX.Element}
   */
  render() {

    let styleCSS = {
      height: 100 + '%',
      backgroundPosition: 'center top',
      backgroundImage: 'url(' + this.props.item.picture + ')',
      backgroundSize: 100 + '%',
      backgroundRepeat: 'no-repeat'
    };

    let opacity = {
      opacity: this.props['is-active'] ? 1 : 0
  };

    return <VelocityComponent animation={opacity} duration={1500}>
      <div style={{display: this.props['is-active'] ? 'block' : 'none'}}>
        <div className="bg_slide">
          <div style={styleCSS}></div>
        </div>
        <div className="wrapper">
          {this._renderItem()}

          <div className="bg_slider-descr hover mw-show">
            {this._renderDescription()}
            <span className="bg_slider-title" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.item.text) || '' }}></span>
          </div>
        </div>
      </div>
    </VelocityComponent>;
  }
}

/**
 *
 * @type {{item: Validator<any>}}
 */
BgSliderItem.propTypes = {
  item: PropTypes.object.isRequired,
  onAssetSelect: PropTypes.func
};

export default BgSliderItem;



// WEBPACK FOOTER //
// ./src/components/BgSlide/bg-slider-item.js